import { z } from 'zod';

export const AdminImportBatchBodySchema = z.object({
  customerId: z.string(),
  templateId: z.string(),
  declarantId: z.string(),
  userId: z.string(),
});

export type AdminImportBatchBody = z.infer<typeof AdminImportBatchBodySchema>;
